import React from 'react';

import AiGenerativeTextSummaryIcon from '@atlaskit/icon/core/ai-generative-text-summary';

export const SummarizeIcon = (): React.JSX.Element => (
	<AiGenerativeTextSummaryIcon label="" color="currentColor" spacing="spacious" />
);
